import React from "react";

/**
 * Yatay adım göstergesi (wizard/sihirbaz).
 * Atomic design: molekül (atomlardan bağımsız, tek amaçlı).
 *
 * @param {string[]} steps   Adım etiketleri
 * @param {number} current   1 tabanlı aktif adım
 */
export default function Stepper({ steps = [], current = 1 }) {
  return (
    <div className="flex items-start w-full">
      {steps.map((label, i) => {
        const stepNo = i + 1;
        const isDone = stepNo < current;
        const isActive = stepNo === current;
        const isLast = i === steps.length - 1;
        return (
          <React.Fragment key={label}>
            <div className="flex flex-col items-center shrink-0 w-20">
              <div
                className={`flex items-center justify-center w-8 h-8 rounded-full text-sm font-semibold transition-colors ${
                  isActive
                    ? "bg-indigo-600 text-white ring-4 ring-indigo-100"
                    : isDone
                    ? "bg-indigo-600 text-white"
                    : "bg-gray-200 text-gray-500"
                }`}
              >
                {isDone ? (
                  <svg
                    className="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={3}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                ) : (
                  stepNo
                )}
              </div>
              <span
                className={`mt-1.5 text-[11px] font-medium text-center leading-tight ${
                  isActive || isDone ? "text-indigo-600" : "text-gray-400"
                }`}
              >
                {label}
              </span>
            </div>
            {!isLast && (
              <div
                className={`flex-1 h-0.5 mt-4 rounded transition-colors ${
                  isDone ? "bg-indigo-600" : "bg-gray-200"
                }`}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
